var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"title":_vm.title,"aria-label":_vm.ariaLabel || _vm.title},on:{"click":_vm.onDismiss}},[_c('CloseIcon',{attrs:{"alt":_vm.imageAlt || _vm.ariaLabel || _vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }